import React, { Component } from "react";

class BillingCycleSwitch extends Component {
    handleToggle = () => {
        const { billingCycle, setBillingCycle } = this.props;
        setBillingCycle(billingCycle === "months" ? "years" : "months");
    };

    render() {
        const { billingCycle } = this.props;
        return (
            <div className="billing-switch d-flex justify-content-center gap-2">
                <h3
                    className={`billing-label ${
                        billingCycle === "months" ? "text-primary" : "text-muted"
                    }`}
                >
                    Mensual
                </h3>
                <label className="switch">
                    <input
                        type="checkbox"
                        checked={billingCycle === "years"}
                        onChange={this.handleToggle}
                    />
                    <span className="billing-label"> </span>
                </label>
                <h3
                    className={`billing-label ${
                        billingCycle === "years" ? "text-primary" : "text-muted"
                    }`}
                >
                    Anual (Ahorra un 25%)
                </h3>
            </div>
        );
    }
}

export default BillingCycleSwitch;
